import styled from 'styled-components';
import { IC_BTN_ARROW_QUICK } from '../../../Assets/images/index';

export const ButtonStyled = styled.div`
  .primary {
    border-radius: 8px;
    height: 52px;
    width: 100%;
    border: 1px solid ${(props) => props.theme.blue.dark};
    background-color: ${(props) => props.theme.blue.dark};
    color: ${(props) => props.theme.color.white};
    font-size: 17px;
    line-height: 21px;
    font-weight: 700;
    &.grey {
       background-color: rgba(176, 190, 197, 0.3);
       border: 1px solid rgba(176, 190, 197, 0.3);
       color: ${(props) => props.theme.text.medium};
      }
  }
  .secondary {
    border-radius: 8px;
    height: 52px;
    width: 100%;
    border: 1px solid ${(props) => props.theme.blue.off};
    background-color: ${(props) => props.theme.blue.off};
    color: ${(props) => props.theme.blue.dark};
    &.grey {
      color: ${(props) => props.theme.blue.grey};
    }
    font-size: 17px;
    line-height: 21px;
    font-weight: 700;
  }
  .primary-outlined {
    border-radius: 8px;
    height: 52px;
    width: 100%;
    border: 1px solid ${(props) => props.theme.blue.dark};
    background-color: ${(props) => props.theme.color.white};
    color: ${(props) => props.theme.blue.dark};
    font-size: 17px;
    line-height: 21px;
    font-weight: 700;
  }
  .rounded-corner {
    border-radius: 8px;
    height: 52px;
    width: 100%;
    border: 0;
    font-size: 14px;
    line-height: 21px;
    font-weight: 600;
    background: ${(props) => props.theme.color.white};
    color: ${(props) => props.theme.text.medium};
    box-shadow: 0px 4px 7px rgba(0, 0, 0, 0.12);
  }
  .danger {
    border-radius: 8px;
    height: 52px;
    width: 100%;
    border: 1px solid ${(props) => props.theme.verification.red.main};
    background-color: ${(props) => props.theme.verification.red.main};
    color: ${(props) => props.theme.color.white};
    font-size: 17px;
    line-height: 21px;
    font-weight: 700;
  }
  .rounded-corner-up-arrow {
    height: 36px;
    width: 125px;
    border: 0;
    font-size: 14px;
    line-height: 23px;
    font-weight: 600;
    background: ${(props) => props.theme.color.white};
    color: ${(props) => props.theme.text.medium};
    box-shadow: 0px 4px 7px rgba(0, 0, 0, 0.12);
    border-radius: 53px;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon {
      width: 14px;
      height: 9px;
      margin-right: 6px;
      transform: rotate(180deg);
      background: url(${IC_BTN_ARROW_QUICK.src}) no-repeat;
    }
  }
  .rounded-corner-down-arrow {
    height: 36px;
    width: 125px;
    border: 0;
    font-size: 14px;
    line-height: 23px;
    font-weight: 600;
    background: ${(props) => props.theme.color.white};
    color: ${(props) => props.theme.text.medium};
    box-shadow: 0px 4px 7px rgba(0, 0, 0, 0.12);
    border-radius: 53px;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon {
      width: 14px;
      height: 9px;
      margin-right: 6px;
      transform: rotate(360deg);
      background: url(${IC_BTN_ARROW_QUICK.src}) no-repeat;
    }
  }
 
`;
